import { render } from "./relate.html?vue&type=template&id=148a8e5b&scoped=true&ts=true"
import script from "./relate.ts?vue&type=script&lang=ts"
export * from "./relate.ts?vue&type=script&lang=ts"

import "./relate.scss?vue&type=style&index=0&id=148a8e5b&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148a8e5b"]])

export default __exports__